<template>
  <h1 :id="content.key" class="title">
    <span>{{ content.text }}</span>
  </h1>
</template>
<script>
/*
绪论标题-1
*/
export default {
  name: "title-1",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  width: 100%;
  height: 110rem;
  background: #3F83E4;

  >span{
    display: block;
    font-size: 48rem;
    line-height: 110rem;
    font-weight: bold;
    color: #fff;
    margin: 0 57rem;
  }
}
</style>